import React, { useEffect, useState } from 'react';
import FileUploadInput from './FileUploadInput';
import FilePreviewCard from './FilePreviewCard';

const FileUploadWrapper = ({ 
  handleUpload, 
  title, 
  acceptedFileTypes, 
  existingFileName, 
  existingFileUrl,
  showOriginalOnDelete = true,
  onDelete = null,
  onRestore = null
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [isExisting, setIsExisting] = useState(false);
  const [originalFile, setOriginalFile] = useState(null);

  useEffect(() => {
    if (existingFileName && existingFileUrl) {
      const existing = { name: existingFileName, size: 0, url: existingFileUrl };
      setUploadedFile({ name: existingFileName, size: 0 });
      setFilePreview(existingFileUrl);
      setOriginalFile(existing);
      setIsExisting(true);
    }
  }, [existingFileName, existingFileUrl]);

  const handleFileSelect = (file) => {
    setUploadedFile(file);
    setIsExisting(false);
    handleUpload({ target: { files: [file] } });

    // Only create preview for image files, not PDFs
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => setFilePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      // For non-image files (like PDFs), clear the preview
      setFilePreview(null);
    }
  };

  const handleDelete = () => {
    // If custom delete handler is provided, call it
    if (onDelete) {
      onDelete();
      return;
    }

    handleUpload({ target: { files: [] } });

    setUploadedFile(null);
    setFilePreview(null);
    setIsExisting(false);
  };

  const handleRestore = () => {
    if (!originalFile) return;

    // If custom restore handler is provided, call it
    if (onRestore) {
      onRestore(originalFile);
      return;
    }

    // Default restore behavior
    setUploadedFile({ name: originalFile.name, size: 0 });
    setFilePreview(originalFile.url);
    setIsExisting(true);
    handleUpload({ target: { files: [] } });
  };

  return uploadedFile ? (
    <FilePreviewCard
      filePreview={filePreview}
      uploadedFile={uploadedFile}
      isExisting={isExisting}
      onDelete={handleDelete}
    />
  ) : (
    <FileUploadInput
      title={title}
      acceptedFileTypes={acceptedFileTypes}
      onFileSelect={handleFileSelect}
      onRestore={handleRestore}
      originalFile={showOriginalOnDelete ? originalFile : null}
    />
  );
};

export default FileUploadWrapper;
